import React from "react";
import Header from "./Header";
import { Link, useLocation } from "react-router-dom";
import "../styles/LandingSection.css";

const LandingSection = (props) => {
  console.log(props);
  const location = useLocation();
  const imageName = props?.data.imageName;
  const title = props?.data.title;
  const breadcrumb = props?.data.breadcrumb;
  const breadcrumbLinks = props?.data.breadcrumbLinks;

  // Breadcrumb mapping for URL segments
  const breadcrumbMap = {
    // Utah at a Glance pages
    'utah-at-a-glance': 'Utah at a Glance',
    'adventure-activities': 'Adventure Activities',
    'charging-stations': 'Utah Charging Stations',
    'utah-housing': 'Utah Housing',
    'utah-counties': 'Utah Counties',
    'demographics': 'Demographics',
    'jobs': 'Jobs',
    'unemployment-rate': 'Unemployment Rate',
    'geothermal': 'Geothermal',
    'airports': 'Airports',
    'mlm': 'MLM',
    'hospital': 'Hospitals',
    'air-quality': 'Air Quality',
    'zipcode': 'Zip Codes',
    'finance': 'Finance',
    'culture': 'Culture',
    'places-to-visit': 'Places to Visit',
    'agencies': 'Federal Agencies',
    'utah-funfacts': 'Utah Fun Facts',
    'sba-advocacy': 'SBA Advocacy',
    'utah-governor': 'Utah Governor',

    
    // Verticals pages
    'verticals': 'Utah Verticals',
    'manufacturing': 'Manufacturing',
    'information': 'Information',
    'professional-scientific-and-technical-services': 'Professional, Scientific, and Technical Services',
    'food-industry': 'Food Industry',
    'transportation-and-warehousing': 'Transportation and Warehousing',
    'architecture-and-construction': 'Architecture and Construction',
    'construction': 'Construction',
    'aerospace-and-defense': 'Aerospace and Defense'
  };

  // Generate breadcrumb from URL if not provided
  const generateBreadcrumbFromUrl = () => {
    const pathSegments = location.pathname.split('/').filter(segment => segment !== '');
    
    // Don't show breadcrumb for parent pages (only one segment) or home page
    if (pathSegments.length <= 1) return null;
    
    const breadcrumbParts = [];
    const breadcrumbLinkParts = [];
    let currentPath = '';
    
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const displayName = breadcrumbMap[segment] || segment.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
      
      breadcrumbParts.push(displayName);
      if (index < pathSegments.length - 1) {
        breadcrumbLinkParts.push(currentPath);
      }
    });
    
    return {
      breadcrumb: breadcrumbParts.join(' >> '),
      breadcrumbLinks: breadcrumbLinkParts
    };
  };
  
  const renderBreadcrumb = () => {
    // Use provided breadcrumb or generate from URL
    const breadcrumbData = breadcrumb ? 
      { breadcrumb, breadcrumbLinks } : 
      generateBreadcrumbFromUrl();
    
    if (!breadcrumbData) return null;
    
    if (breadcrumbData.breadcrumbLinks && breadcrumbData.breadcrumbLinks.length > 0) {
      // Render breadcrumb with links
      const parts = breadcrumbData.breadcrumb.split(' >> ');
      return (
        <div className="breadcrumb" style={{ 
          fontSize: '14px', 
          marginBottom: '10px',
          color: 'white',
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          {parts.map((part, index) => (
            <span key={index}>
              {index < parts.length - 1 ? (
                <Link 
                  to={breadcrumbData.breadcrumbLinks[index] || '#'} 
                  style={{ 
                    color: 'white', 
                    textDecoration: 'underline',
                    textShadow: '2px 2px 4px rgba(0,0,0,1)'
                  }}
                  onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                  onMouseOut={(e) => e.target.style.textDecoration = 'underline'}
                >
                  {part}
                </Link>
              ) : (
                <span style={{ textShadow: '2px 2px 4px rgba(0,0,0,1)' }}>
                  {part}
                </span>
              )}
              {index < parts.length - 1 && <span> >>&nbsp;</span>}
            </span>
          ))}
        </div>
      );
    } else {
      // Render simple breadcrumb without links
      return (
        <div className="breadcrumb" style={{ 
          fontSize: '14px', 
          marginBottom: '10px',
          color: 'white',
          textAlign: 'center',
          textShadow: '2px 2px 4px rgba(0,0,0,1)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          {breadcrumbData.breadcrumb}
        </div>
      );
    }
  };

  return (
    <>
      <div
        className="landing"
        style={{ backgroundImage: `url(/img/landing-webp/${imageName})` }}
      >
        <div className={props.data.visible ? "landing-overlay" : null}>
          <Header />
          <div className="landing_content "
          style={{ textShadow: '2px 2px 4px rgba(0,0,0,1)' }}>
            {renderBreadcrumb()}
            <h1>{title}</h1>
            <p>[SCROLL TO SEE]</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingSection;
